<template>
  <div>
    <!-- <DropdownMenu style="position: fixed; z-index: 10; top: 0; width: 100%">
      <DropdownItem v-model="value" :options="option" @change="onChangeCompanyId"/>
    </DropdownMenu> -->
    <div class="fiexd-top">
      <div class="type-row">
        <div class="type-item" @click="isShow=true">{{companyName||'所属站点'}}<Icon name="arrow" /></div>
        <div class="type-item" @click="isVis=true">{{productName||'货品分类'}}<Icon name="arrow" /></div>
      </div>
      <div class="type-time">
        <div class="time-item" @click="isVisTime=true;timeType='start'">{{startDate}} <Icon name="play" class="down-icon" size="12px" color="#4ba937"/></div>
        <div class="time-center">-</div>
        <div class="time-item" @click="isVisTime=true;timeType='end'">{{endDate}} <Icon name="play" class="down-icon" size="12px"  color="#4ba937" /></div>
        <div style="flex:1"></div>
        <div class="time-search" @click="getData">
          <Icon name="search" color="#fff"/>
        </div>
      </div>
    </div>
    <div class="main-box">
      <div id="main" class="main" v-show="!isNoData"></div>
      <Empty v-show="isNoData" description="暂无数据" style="width:100%"></Empty>
    </div>

    <Popup v-model="isShow" position="bottom">
      <Picker
        title="站点选择"
        :columns="option"
        @confirm="onConfirm"
        @cancel="isShow=false"
        show-toolbar
      />
    </Popup>

    <Popup v-model="isVis" position="bottom">
        <div class="p-top">
          <div @click="isVis=false" class="ptop-btns">取消</div>
          <div class="ptop-center">品类选择</div>
          <div class="ptop-btns" @click="getProductId">确定</div>
        </div>
        <div class="p-content">
          <div class="p-left">
            <ul class="p-first-type">
              <li v-for="item in firstPlist" :class="{'check_first':(firstCheck==item.id)}" :key="item.id" @click="getSecond(item.id,item.productList)">{{item.name}}</li>
            </ul>
          </div>
          <div class="p-right">
            <div class="second-item-box"  v-for="item in secondFirstPlist" :key="item.productId" @click="secondCheck=item.productId">
              <div class="second-item" :class="{'check_first':(secondCheck==item.productId)}">{{item.productName}}</div>
            </div>
            
          </div>
        </div>
    </Popup>

    <Popup v-model="isVisTime" >
      <div class="data-type-row">
        <div class="data-type-title">查询条件：</div>
        <RadioGroup v-model="dateType" direction="horizontal" icon-size="18px">
          <Radio :name="0">过毛日期</Radio>
          <Radio :name="1">过皮日期</Radio>
        </RadioGroup>
      </div>
      <div class="data-type-btns">
        <Button size="small" style="width:80px" @click="getDateTime('day')">今日</Button>
        <Button size="small" style="width:80px" @click="getDateTime('month')">本月</Button>
        <Button size="small" style="width:80px" @click="getDateTime('year')">本年</Button>
      </div>
      <Calendar style="width:300px" @choseDay="choseDay"></Calendar>
    </Popup>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { DropdownMenu, DropdownItem, Sticky, Toast, Icon, Popup, Picker, RadioGroup, Radio, Button,Empty   } from "vant";
import {
  tabBaseCompanyEntity,
  StatisticsDeliveryQuantity,
  selectAllProductAndType
} from "../../api/inlayApi";
import Calendar from "vue-calendar-component";

function timeFormat(date) {
    if (!date || typeof(date) === "string") {
        this.error("参数异常，请检查...");
    }
    var y = date.getFullYear(); //年
    var m = doubleNum(date.getMonth() + 1); //月
    var d = doubleNum(date.getDate()); //日

    return y + "-" + m + "-" + d;
}

function doubleNum(num) {
    var num = parseInt(num)
    if (num >= 1 && num <= 9) {
        num = "0" + num;
    }
    return num
}

function monthday(){ //本月
    var todate = new Date();
    var currentdate = timeFormat(todate)
    todate.setDate(1);
    var monthday = timeFormat(todate)
    return {
        startDate: monthday,
        endDate: currentdate
    }
  }
 function today() { //当天
    var todate = new Date();
    var currentdate = timeFormat(todate)
    return {
      startDate: currentdate,
      endDate: currentdate
    }
}
 function differDay(date1,date2){
  console.log(date2)
  // var date1=new Date(2010,10,3);
  // var date2=new Date(2017,9,24);
  var date=(date2.getTime()-date1.getTime())/(1000*60*60*24);/*不用考虑闰年否*/
  return date
}

  function yearday() { //本年
    var todate = new Date();
    var currentdate = timeFormat(todate)
    todate.setDate(1);
    todate.setMonth(0);
    var monthday = timeFormat(todate)
    return {
      startDate: monthday,
      endDate: currentdate
    }
}

export default {
  data() {
    return {
      value: 0,
      option: [],
      isShow:false,
      companyName:'',
      isVis:false,
      firstPlist:[],
      firstCheck:0,
      secondFirstPlist:[],
      secondCheck:0,
      isVisTime:false,
      dateType:0,
      timeType:'start',
      startDate:'',
      endDate:'',
      productId:'',
      productName:'',
      companyId:0,
      level:null,
      isNoData:false 
    };
  },
  components: {
    DropdownMenu,
    DropdownItem,
    Sticky,
    Icon,
    Popup,
    Picker,
    Calendar,
    RadioGroup, 
    Radio,
    Button,
    Empty
  },
  legend:{
    
  },
  created(){
    let {startDate, endDate}= monthday()
    this.startDate = startDate
    this.endDate = endDate
  },
  mounted() {
    // this.$nextTick(() => {

    // })
    this.companyId = this.$route.query.companyId||0;
    this.getCompany()
    this.getData();
    this.AllProductAndType()
  },
  methods: {
    getProductId(){
      if(this.secondCheck){
        this.productId = this.secondCheck
        this.productName = this.secondFirstPlist.find(item=>item.productId == this.secondCheck).productName
        this.level = 2
      }else{
        this.level = 1
        this.productId = this.firstCheck
        this.productName = this.firstPlist.find(item=>item.id == this.firstCheck).name
      }
      this.isVis = false
      this.getData()
    },
    getDateTime(type){
      let {startDate, endDate}= type=='day'?today():type=='month'?monthday():yearday()
      this.startDate = startDate
      this.endDate = endDate
      this.isVisTime = false
    },
    choseDay(data){
      let newData = data.split('/').map(item=>{
          return doubleNum(item)
        }).join('-')
      if(this.timeType == "start"){
        this.startDate = newData
        console.log(this.startDate)
      }else{
        this.endDate = newData
      }
      this.isVisTime = false
    },
    
    getSecond(id,secondList){
      this.firstCheck = id
      this.secondFirstPlist = secondList
      this.secondCheck = 0
    },
   AllProductAndType(){
    let token = this.$route.query.token;
    let groupId = this.$route.query.groupId;
    selectAllProductAndType({
      groupId,
      token
    }).then(res=>{
      if(res.respCode=='100200'){
        this.firstPlist = [{name:'全部',id:0},...res.data]
      }else{
        Toast.fail(res.msg);
      }
    })
   },
    onConfirm(event){
      
      this.companyName = event.text
      this.companyId  = event.value
      this.isShow = false
      this.getData()
    },
    //获取分站
    getCompany() {
      let token = this.$route.query.token;
      let companyId = this.$route.query.companyId;
      tabBaseCompanyEntity({ token,pageCount:1,pageSize:100}).then((res) => {
        let { respCode, msg, data } = res;
        if (respCode == "100200") {
          data = data.records.map((item) => {
            return {
              text: item.name,
              value: item.id,
            };
          });
          if(companyId&&companyId!='0'){
            data = data.filter(item=>item.value==companyId)
          }
          if(data.length>1){
            this.option = [{ text: "全部", value: 0 }, ...data];
          }else{
            this.option = data
            this.value = data[0].value
            this.companyName = data[0].text
          }
          
        } else {
          Toast.fail(msg);
        }
      });
    },
    //获取统计数据
    getData() {
      let token = this.$route.query.token;
      let { companyId, dateType, startDate, endDate, productId,level } = this
      if(differDay(new Date(startDate),new Date(endDate))<0){
        Toast.fail('初始时间必须小于结束时间！');
        return
      }
      if(differDay(new Date(startDate),new Date(endDate))>366){
        Toast.fail('日期查询范围不可超过一年！');
        return
      }
      StatisticsDeliveryQuantity(token,{companyId,dateType, startDate, endDate, productId,level }).then((res) => {
        let { respCode,  data, msg} = res
        let { list, unitsMeasure } = data
        if(respCode=='100200'){
          if(!list.length){
            this.isNoData = true
          }else{
            this.isNoData = false
          }
          let unit = unitsMeasure=='T'?'吨':'kg'
          let nameData = list.map(item=>{
            const originalSname = item.sname; // 保存原始名称
            if(item.sname.length>8){
              item.sname = item.sname.slice(0,8) +'...'
            }
            return {
                value: "{a|"+item.sname + "}\n{b|"+ item.countWeight + unit +"}\n{b|"+ item.countAmount +'元'+"}",
                originalSname: originalSname, // 将原始名称存储在对象中
                textStyle: {
                  lineOverflow: true,
                  rich: {
                    a: {
                      color: "#000",
                      lineHeight: 15,
                    },
                    b: {
                      color: "#999",
                      lineHeight: 15,
                    },
                  },
                },
              }
          })
          
          let numData = list.map(item=>item.countWeight)
          if(nameData&&nameData.length){
            this.sMap(nameData,numData)
          }else{
            this.sMap([],[])
          }
          
        }else{
           Toast.fail(msg);
        }

      });
    },
    //绘制条形统计图
    sMap(nameData, numData) {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;
      var showLength = 8;
      var maxLength = nameData.length;
      let startValue = 0
      if(maxLength>10){
        startValue = maxLength - showLength
      }

      // 创建一个映射，将显示名称对应到原始名称
      const originalNameMap = {};
      nameData.forEach((item, index) => {
        originalNameMap[item.value] = item.originalSname;
      });
      
      option = {
        color: "#4ba937",
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function(params) {
            const data = params[0];
            const valueStr = data.name;

            // 从映射中获取原始名称
            const originalSname = originalNameMap[valueStr] || '';

            // 提取所有 {b|...} 中的内容
            const bMatches = Array.from(valueStr.matchAll(/\{b\|([^}]+)\}/g), m => m[1]);

            const weight = bMatches[0] || '';
            const amount = bMatches[1] || '';

            return `
              <div style="padding: 5px; font-size: 12px;">
                <p><strong>${originalSname}</strong></p>
                <p>重量：${weight}</p>
                <p>金额：${amount}</p>
              </div>
            `;
          },
        },
        dataZoom: {
          zoomLock: true,
          type: "inside",
          orient: "vertical",
          startValue: startValue,
          maxValueSpan: showLength,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
          
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            rotate: -45,
          },
        },
        yAxis: {
          nameLocation: "middle",
          type: "category",
          data: nameData,
        },
        series: [
          {
            name: "2021年",
            type: "bar",
            data: numData,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
<style lang="scss">
.main-box {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  padding: 80px 10px 0;
  display: flex;
}
.main {
  flex: 1;
}

.fiexd-top{
  position: relative;
  z-index: 10;
  padding-top: 10px;
  .type-row{
    display: flex;
    height: 20px;
    .type-item{
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
  }
  .type-time{
    display: flex;
    margin: 10px 15px 0;
    border-bottom: 1px solid #4ba937;
    .time-item{
      color: #4ba937;
      width: 110px;
      display: flex;
      align-items: center;
      .down-icon{
        transform: rotate(90deg);
        margin-left: 5px;
      }
    }
    .time-center{
      color: #4ba937;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-items: center;
    }
    .time-search{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #4ba937;
      width: 35px;
      height: 35px;
      border-top-right-radius: 20px;
      border-top-left-radius: 20px;
    }
  }
}

.p-top{
  display: flex;
  border-bottom: 1px solid #eee;
  .ptop-btns{
    width: 80px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ptop-center{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.p-content{
  display: flex;
  height: 250px;
  
  .p-left{
    width: 80px;
    border-right: 1px solid #eee;
    overflow: auto;
    .check_first{
      background-color: #4ba937;
      color: #fff;
    }
    .p-first-type{
      li{
        // display: flex;
        // justify-content: center;
        // align-self: center;
        border-bottom: 1px solid #eee;
        padding: 10px 5px;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }
  .p-right{
    flex: 1;
    overflow: auto;
    // display: flex;
    flex-wrap: wrap;
    background-color: #f2f2f2;
    .second-item-box{
      width: 50%;
      box-sizing: border-box;
      padding: 5px;
      height: 45px;
      float: left;
      .second-item{
        &.check_first{
          background-color: #4ba937;
          color: #fff;
        }
        background-color: #fff;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        text-align: center;
        line-height: 35px;
        height: 35px;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding:0 5px;
      }
    }
  }
}

.data-type-row{
  display: flex;
  padding: 20px 0;
  font-size: 14px;
  justify-content: center;
  align-items: center;
}
.data-type-btns{
  display: flex;
  justify-content: space-around;
}
.wh_jiantou2[data-v-2ebcbc83]{
  border-top: 2px solid #333!important;
  border-right: 2px solid #333!important;
}
.wh_jiantou1[data-v-2ebcbc83]{
  border-top: 2px solid #333!important;
  border-left: 2px solid #333!important;
}
.wh_top_changge li[data-v-2ebcbc83]{
  color: #333!important;
}
.wh_content_item[data-v-2ebcbc83], wh_content_item_tag[data-v-2ebcbc83]{
  color: #333!important;
}
.wh_content_all[data-v-2ebcbc83]{
  background-color:#fff!important
}
.wh_content_item .wh_chose_day[data-v-2ebcbc83] {
  background: #4ba937!important;
  color: #fff!important;
}

.wh_content_item .wh_isToday[data-v-2ebcbc83]{
  background: #e9eaee!important;
}
</style>



// WEBPACK FOOTER //
// src/views/H5/sMap.vue